export const SIDEBAR_STATUS = 'SIDEBAR_STATUS';